module.exports = __webpack_public_path__ + "img/login-bg.3c667ab3.png";